import { useTranslation } from 'react-i18next';

import { MonthlyTransactionsSummaryDataGrid } from '~features/finances';

import Page from '../page';

const MonthlyTransactionsSummaryPage = () => {
	const { t } = useTranslation();

	return (
		<Page title={t('transactions')}>
			<MonthlyTransactionsSummaryDataGrid />
		</Page>
	);
};

export default MonthlyTransactionsSummaryPage;
